import config from './config/login'
import axios from '@/utils/request'
export const login = params => axios.post(config.login, params) // 登录
export const userInfo = params => axios.get(config.userInfo, params) // 用户信息
